
import { Link } from "react-router-dom";

interface BlogCardProps {
  id: string;
  title: string;
  excerpt: string;
  image: string;
  date: string;
  category: string;
}

const BlogCard = ({ id, title, excerpt, image, date, category }: BlogCardProps) => {
  return (
    <article className="hover-lift">
      <Link to={`/blog/${id}`}>
        <div className="overflow-hidden rounded-lg mb-4">
          <img
            src={image}
            alt={title}
            className="w-full h-48 md:h-64 object-cover transition-transform duration-300 hover:scale-105"
            loading="lazy"
            width="600"
            height="400"
          />
        </div>
      </Link>
      <div>
        <div className="flex items-center mb-2">
          <span className="text-xs text-bunnie-peach font-medium">{category}</span>
          <span className="mx-2 text-bunnie-brown/30">•</span>
          <time className="text-xs text-bunnie-brown/60">{date}</time>
        </div>
        <Link to={`/blog/${id}`}>
          <h3 className="font-serif text-xl text-bunnie-brown mb-2 hover:text-bunnie-brown/80 transition-colors">
            {title}
          </h3>
        </Link>
        <p className="text-bunnie-brown/70 text-sm line-clamp-2">{excerpt}</p>
        <Link 
          to={`/blog/${id}`}
          className="inline-block mt-3 text-bunnie-brown font-medium text-sm relative after:absolute after:bottom-0 after:left-0 after:w-full after:h-px after:bg-bunnie-brown after:origin-right after:scale-x-0 hover:after:origin-left hover:after:scale-x-100 after:transition-transform after:duration-300"
        >
          Read more about {title}
        </Link>
      </div>
    </article>
  );
};

export default BlogCard;
